// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { useShellStore } from '../../stores/shellStore';
import * as authService from '../../services/authService';
import Button from './Button';
import './SessionExpiredModal.css';

/**
 * Forced re-auth prompt shown when the backend rejects the session token
 * (401). Non-dismissable: the only way out is to log out and sign back in.
 * Renders only while MSAL still reports an authenticated account so it never
 * appears on the login page.
 */
function SessionExpiredModal() {
  const sessionExpired = useShellStore(s => s.sessionExpired);
  const setSessionExpired = useShellStore(s => s.setSessionExpired);
  const isAuthenticated = useIsAuthenticated();

  if (!sessionExpired || !isAuthenticated) return null;

  const handleReauth = async () => {
    setSessionExpired(false);
    await authService.logout();
  };

  return (
    <div className="session-expired-overlay" role="alertdialog" aria-modal="true">
      <div className="session-expired-panel">
        <h2 className="session-expired-title">Session expired</h2>
        <p className="session-expired-body">
          Your session has expired. Please log out and sign back in to continue.
        </p>
        <div className="session-expired-actions">
          <Button variant="primary" onClick={handleReauth}>
            Log out &amp; sign in again
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SessionExpiredModal;
